module.exports = __webpack_public_path__ + "images/avatars/event_avatar_default.c1b058d9a4d98452bd36f661948cfaed.png";